export default __webpack_public_path__ + "static/media/2.2c447f1c.jpg";